import React from 'react';
import { Form, Input, Select, Row, Col, message, Button } from 'antd';
import ModalDom from '../../../../components/Modal';
import { post, postFrom, config } from '../../../../axios';
import { CustomRow, CustomCol } from '../../../../components/Custom';
import { dicMerchantDepartmentStatus } from '../../../../axios/dictionaries';

const Option = Select.Option;

class Page extends React.Component {
    constructor() {
        super();
        this.state = {
            loading: false,
            data: {},
            title: '新增部门',
            id: '',
            inputWidth: 260,
            isAdmin: 1 //是否为商户管理员
        }
    }

    render() {
        let { visible, form: { getFieldDecorator }  } = this.props;
        let { loading, data, title, inputWidth, isAdmin } = this.state;

        const footer = () =>  {
            let dom  = isAdmin == 1 ? null : <div><Button onClick={this.handleCancel}>取消</Button></div>
            return dom
        }

        return <ModalDom
            title={title}
            visible={visible}
            loading={loading}
            onOk={this.handleOk}
            width={"800px"}
            onCancel={this.handleCancel}
            footer = { footer() }
        >
            <div className="custom">
            <Form
                labelCol={{ span: 0 }}
                wrapperCol={{ span: 24 }}
                className="min-height "
            >
                 <Row>
                     {
                         isAdmin == 1 ?
                             <Col span={24}>
                                 <CustomRow>
                                     <CustomCol  label="部门名称">
                                         {getFieldDecorator('name', {
                                             rules: [{
                                                 required: true, message: '请输入部门名称',
                                             }],
                                             initialValue: data.name
                                         })(
                                             <Input
                                                 placeholder={'请输入'}
                                                 
                                                 autoComplete={'off'}
                                             />
                                         )}
                                     </CustomCol>
                                 </CustomRow>
                                 <CustomRow divider>
                                     <CustomCol  label="使用状态">
                                         {getFieldDecorator('status', {
                                             rules: [{
                                                 required: true, message: '请选择使用状态',
                                             }],
                                             initialValue: data.status || 1
                                         })(
                                             <Select
                                                 showSearch
                                                 
                                                 placeholder="请选择"
                                                 optionFilterProp={'children'}
                                             >
                                                 {dicMerchantDepartmentStatus.map((item, index) => <Option key={ index } value={ item.value }>{ item.title }</Option>)}
                                             </Select>
                                         )}
                                     </CustomCol>
                                 </CustomRow>
                             </Col>
                             :
                             <Col span={24}>
                                 <CustomRow>
                                     <CustomCol label="部门名称：" labelStyle={{ width: '100px' }}>
                                         <div style={{ width: inputWidth, padding: '0 10px', height: '34px', lineHeight: '34px', fontSize: '16px', overflow: 'auto' }}>{data.name}</div>
                                     </CustomCol>
                                 </CustomRow>
                                 <CustomRow divider>

                                     <CustomCol label="使用状态：" labelStyle={{ width: '100px' }}>
                                         <div style={{ width: inputWidth, padding: '0 10px', height: '34px', lineHeight: '34px', fontSize: '16px', overflow: 'auto' }}>{data.status == 1 ? '正常' : '停用'}</div>
                                     </CustomCol>
                                 </CustomRow>
                             </Col>
                     }

                </Row>

            </Form>
            </div>
        </ModalDom>
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    handleCancel = () => {
        this.props.handleCancel();
        this.setState({data: {}, loading: false, title: "新增部门" })
    }


    loadPack = ({id, platformisAdmin}) => {
        this.setState({ loading: true, title: "编辑部门", id });
        let data = { merchantDepartmentId: id };
        postFrom({
            url: config.API_merchantdepartment_getById,
            data,
        }).then(res => {
            this.setState({ data: res, loading: false });
            if(platformisAdmin == 0) {
                this.setState({ isAdmin : platformisAdmin })
            }
        }).catch(err => {
            message.error(err.message || '获取详情失败');
            this.setState({ loading: false });
        })



    }

    handleOk = () => {
        this.props.form.validateFieldsAndScroll((error, values) => {

            if(!error) {
                this.setState({loading: true});
                let data = {},
                NOW_URL = '',
                responText = '';
                data = Object.assign({}, values, { merchantId: this.props.parentMerchantId });

                if(this.props.handlecreateOrEdit){
                    NOW_URL = config.API_merchantdepartment_edit;
                    responText = '编辑';
                    data.id = this.state.id;
                } else {
                    NOW_URL = config.API_merchantdepartment_create;
                    responText = '新增'
                }

                post({
                    url: NOW_URL,
                    data,
                }).then(res => {
                    this.setState({loading: false});
                    this.props.handleGetList();
                    this.handleCancel();
                    message.success(`${responText}成功`);
                }).catch(err => {
                    message.error(err.message || '接口异常');
                    this.setState({ loading: false });
                });
            }
        })
    }
}

export default Form.create()(Page);



// WEBPACK FOOTER //
// ./src/page/Merchant/components/DepartmentAdd/index.js